import type { BaseErrorResponse, GetTreesRes, UpdateTreeReq } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useTree() {
  class Tree<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Tree
     * @name TreeControllerGetTrees
     * @summary Get a list of trees
     * @request GET:/api3/tree
     * @secure
     * @response `200` `GetTreesRes`
     * @response `400` `BaseErrorResponse`
     */
    treeControllerGetTrees = (params: RequestParams = {}) =>
      this.request<GetTreesRes, BaseErrorResponse>({
        path: '/api3/tree',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Tree
     * @name TreeControllerUpdateTree
     * @summary Update tree
     * @request PUT:/api3/tree
     * @secure
     * @response `200` `GetTreesRes`
     * @response `400` `BaseErrorResponse`
     */
    treeControllerUpdateTree = (data: UpdateTreeReq, params: RequestParams = {}) =>
      this.request<GetTreesRes, BaseErrorResponse>({
        path: '/api3/tree',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Tree();
}
